import { faXmark } from '@fortawesome/pro-solid-svg-icons';

import { Icon, IconButton, cn, useRebrand } from '@growtherapy/sprout-ui';

import { ToastRenderFnProps, ToastVariant } from './types';

export type ToastCloseButtonProps = {
  size?: 'xs' | 'sm';
  variant?: ToastVariant;
} & ToastRenderFnProps['closeButtonProps'];

export function ToastCloseButton({ size = 'xs', variant, ...ariaProps }: ToastCloseButtonProps) {
  const rebrand = useRebrand();

  if (rebrand) {
    return (
      <button
        {...ariaProps}
        type='button'
        aria-label='Dismiss'
        className={cn({
          'text-status-success-text': variant === ToastVariant.Success,
          'text-status-error-text': variant === ToastVariant.Error,
          'text-text-default': variant === ToastVariant.Info,
        })}
      >
        <Icon icon={faXmark} />
      </button>
    );
  }

  return (
    <IconButton
      {...ariaProps}
      type='button'
      iconDefinition={faXmark}
      className={cn('text-neutral-800 no-underline hover:text-neutral-800 flex justify-center items-center', {
        'h-9 w-9': size === 'sm',
        'h-6 w-6': size === 'xs',
      })}
      use='secondary'
      aria-label='Dismiss'
      size={size === 'sm' ? 'md' : 'sm'}
    />
  );
}
